import React from 'react'
import styled, { css } from 'styled-components'
import { P } from '@mote/ui'
import { TickFilledIcon } from '@mote/assets/icons'
import { Card } from './Card'

export const OptionCard = ({
  className,
  icon,
  text,
  isSelected,
  onSelection
}) => {
  return (
    <Root className={className} selected={isSelected} onClick={onSelection}>
      <SelectedIndicatorContainer isSelected={isSelected}>
        <TickFilledIcon />
      </SelectedIndicatorContainer>
      <Body>
        {icon && (
          <IconContainer role='img' aria-label='emoji'>
            {icon}
          </IconContainer>
        )}
        <P
          fontSize={15}
          lineHeight='140%'
          fontWeight={500}
          alignment='center'
          color='#25252D'
        >
          {text}
        </P>
      </Body>
    </Root>
  )
}

const Root = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  border: 1.5px solid transparent;
  transition: all 150ms ease-in;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    box-shadow: 0px 1px 3px rgba(113, 101, 129, 0.04),
      0px 3px 14px rgba(113, 101, 129, 0.08),
      0px 8px 32px rgba(113, 101, 129, 0.1);
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: #ac0ae8;
    `}

  @media (max-width: 639px) {
    flex-direction: row;
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (max-width: 639px) {
    flex-direction: row;
    gap: 8px;
  }
`

const SelectedIndicatorContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  transition-duration: 100ms;
  transition-timing-function: ease-in;
  transition-property: transform, opacity, visibility;

  ${({ isSelected }) =>
    isSelected
      ? css`
          opacity: 1;
          visibility: visible;
          transform: scale(1);
        `
      : css`
          opacity: 0;
          visibility: hidden;
          transform: scale(0);
        `};

  @media (max-width: 639px) {
    right: 16px;
    top: 50%;

    svg {
      height: 24px;
      width: 24px;
    }

    ${({ isSelected }) =>
      isSelected
        ? css`
            transform: translateY(-50%) scale(1);
          `
        : css`
            transform: translateY(-50%) scale(0);
          `};
  }
`

const IconContainer = styled.span`
  font-size: 24px;
  line-height: 24px;
`
